import React from 'react';
import PropTypes from 'prop-types';

const IconChevronRight = ({ size, fill }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill={fill}
        viewBox="0 0 1015 1675"
    >
        <path d="M0 1549.5q0-51.5 37-88.5l624-623L37 214Q0 177 0 125.5T37 37t89-37 89 37l800 801-800 800q-39 37-89 37t-89-37q-37-37-37-88.5z" />
    </svg>
);

IconChevronRight.propTypes = {
    size: PropTypes.number.isRequired,
    fill: PropTypes.string.isRequired,
};

IconChevronRight.defaultProps = {
    size: 15,
    fill: 'white',
};

IconChevronRight.displayName = 'IconChevronRight';

export default IconChevronRight;
